import React, { useRef, useState } from "react";
import { Camera, Trash2, UserRound } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError, mediaUrl } from "../lib/api";

export const ProfilePhotoEditor = ({ member, onChange }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const fid = member?.avatar_file_id;
  const upload = async (file) => {
    if (!file) return;
    if (!/^image\/(jpeg|png|webp)$/.test(file.type)) return toast.error("Please choose a JPG, PNG or WebP image");
    if (file.size > 5 * 1024 * 1024) return toast.error("Photo must be under 5 MB");
    const fd = new FormData(); fd.append("file", file);
    setBusy(true);
    try { await api.post("/portal/avatar", fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Photo updated"); onChange(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  const remove = async () => {
    try { await api.delete("/portal/avatar"); toast.success("Photo removed"); onChange(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  return (
    <div className="sm:col-span-2 flex items-center gap-4" data-testid="profile-photo-editor">
      {fid ? <img data-testid="profile-photo" src={mediaUrl(fid)} alt="Profile" className="h-16 w-16 rounded-full object-cover border" style={{ borderColor: "var(--sj-border)" }} />
        : <span data-testid="profile-photo-placeholder" className="h-16 w-16 rounded-full flex items-center justify-center" style={{ background: "#E3F1EC", color: "var(--sj-primary)" }}><UserRound className="h-8 w-8" /></span>}
      <div className="flex flex-wrap gap-2">
        <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" data-testid="profile-photo-input" onChange={(e) => upload(e.target.files?.[0])} />
        <button type="button" data-testid="profile-photo-upload" disabled={busy || !member} onClick={() => ref.current?.click()} className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold border hover:bg-[#E3F1EC] disabled:opacity-50" style={{ borderColor: "var(--sj-border)", color: "var(--sj-primary)" }}>
          <Camera className="h-4 w-4" /> {busy ? "Uploading…" : fid ? "Change photo" : "Add photo"}
        </button>
        {fid && <button type="button" data-testid="profile-photo-remove" onClick={remove} className="inline-flex items-center gap-1.5 rounded-full px-3 py-2 text-sm border hover:bg-[#FDECEC]" style={{ borderColor: "var(--sj-border)", color: "#B91C1C" }}><Trash2 className="h-4 w-4" /> Remove</button>}
        <p className="w-full text-xs" style={{ color: "var(--sj-text-3)" }}>JPG, PNG or WebP, up to 5 MB.</p>
      </div>
    </div>
  );
};
